import * as Sentry from '@sentry/vue';

export const ErrorBoundaryHandler = (error: unknown, sentry: typeof Sentry) => {
  console.error('ErrorBoundaryHandler:', error);
  sentry.captureException(error);
};
